import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, getDocs, doc, setDoc, serverTimestamp, limit } from 'firebase/firestore';

const UpdateStatusPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  const [selectedStatus, setSelectedStatus] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!selectedStatus) {
      alert('Please select a status.');
      return;
    }
    setIsSaving(true);

    try {
      const customersRef = collection(db, 'customer');
      const q = query(customersRef, where('locationId', '==', orderId), limit(1));
      const customerSnapshot = await getDocs(q);

      if (customerSnapshot.empty) {
        throw new Error(`No customer found with the scanned ID: ${orderId}`);
      }

      const customerDoc = customerSnapshot.docs[0];
      const customerId = customerDoc.id;
      const customerName = customerDoc.data().name;

      const statusToSave = selectedStatus === 'Vessel Placed' ? 'vessel_placed' : 'vessel_collected';

      const statusData = {
        customerName: customerName,
        status: statusToSave,
        lastUpdateTime: serverTimestamp(),
        scannedLocationId: orderId,
      };

      const statusDocRef = doc(db, 'customer_status', customerId);
      await setDoc(statusDocRef, statusData, { merge: true });

      alert('Status updated successfully!');
      navigate('/delivery-status');
    } catch (error) {
      console.error('FAILED TO UPDATE STATUS:', error);
      alert(`Error: ${error.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  const pageStyles = { padding: '2rem', maxWidth: '600px', margin: '0 auto', textAlign: 'center' };
  const buttonContainerStyles = { display: 'flex', flexDirection: 'column', gap: '1rem', margin: '2rem 0' };
  const statusButtonStyles = { padding: '1rem', fontSize: '18px', cursor: 'pointer', border: '2px solid #ccc', borderRadius: '8px', background: '#60a5fa' };
  const selectedButtonStyles = { ...statusButtonStyles, background: '#ff4a4aff', color: 'white', borderColor: '#2563eb' };
  const saveButtonStyles = { padding: '1rem', fontSize: '18px', fontWeight: 'bold', cursor: 'pointer', border: 'none', borderRadius: '8px', background: '#10b981', color: 'white' };

  return (
    <div style={pageStyles}>
      <h1>Update Customer Status</h1>
      <p style={{ color: '#666', wordBreak: 'break-all' }}>Scanned ID: {orderId}</p>
      <div style={buttonContainerStyles}>
        <button style={selectedStatus === 'Vessel Placed' ? selectedButtonStyles : statusButtonStyles} onClick={() => setSelectedStatus('Vessel Placed')}>Vessel Placed</button>
        <button style={selectedStatus === 'Vessel Collected' ? selectedButtonStyles : statusButtonStyles} onClick={() => setSelectedStatus('Vessel Collected')}>Vessel Collected</button>
      </div>
      <button style={saveButtonStyles} onClick={handleSave} disabled={isSaving}>{isSaving ? 'Saving...' : 'Save Status'}</button>
    </div>
  );
};

export default UpdateStatusPage;
